<div class="container">
    <ng-container *ngFor="let item of data">
        <div class="container__pillow">
            <p class="container__custom-paragraph">{{ item?.toUpperCase() }}</p>
            <mat-icon class="container__icon" (click)="removeKeyword(item)">
                close
            </mat-icon>
        </div>
    </ng-container>
</div>